/**
 * Inventories API Queries
 *
 * Query keys and read operations.
 */

import { apiClient } from '../client';
import type { InventoriesResponse, InventoryShowResponse, FetchInventoriesParams } from './types';

export const inventoriesQueryKeys = {
  all: ['inventories'] as const,
  lists: () => [...inventoriesQueryKeys.all, 'list'] as const,
  list: (params: FetchInventoriesParams) => [...inventoriesQueryKeys.lists(), params] as const,
  detail: (id: number) => [...inventoriesQueryKeys.all, 'detail', id] as const,
};

export async function getInventories(params: FetchInventoriesParams = {}): Promise<InventoriesResponse> {
  const { data } = await apiClient.get<InventoriesResponse>('/api/inventories', { params });
  return data;
}

export async function getInventory(id: number): Promise<InventoryShowResponse> {
  const { data } = await apiClient.get<InventoryShowResponse>(`/api/inventories/${id}`);
  return data;
}
